import { testimonials } from "@/mocks/manga";
import SectionTitle from "./SectionTitle";

export default function Testimonials() {
  return (
    <section id="reviews" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionTitle
          eyebrow="用户口碑"
          title="追更党都在用汗汗虫虫"
          desc="听听真实读者的使用感受，从追更提醒到自动续读，每个人都找到了适合自己的追更方式。"
        />

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6">
              <div className="flex gap-0.5 text-accent-500" aria-label={`${t.rating} 星评价`}>
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-6 text-foreground-700">"{t.quote}"</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 font-heading text-sm text-background-50">
                  {t.name.charAt(0)}
                </span>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}